import { useState } from "react";

interface StringFieldProps {
  label: string;
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  description?: string;
}

export function StringField({ label, value, onChange, placeholder, description }: StringFieldProps) {
  const [showTip, setShowTip] = useState(false);

  return (
    <div className="group/field rounded-radius-sm px-1.5 py-1 transition-colors hover:bg-surface-sunken/50">
      <div className="flex items-center gap-2">
        <div
          className="relative flex w-28 shrink-0 items-center gap-1"
          onMouseEnter={() => { if (description) setShowTip(true); }}
          onMouseLeave={() => setShowTip(false)}
        >
          <span className="truncate text-[11px] text-text-secondary">{label}</span>
          {description && (
            <span className="text-[9px] text-text-muted/40 opacity-0 transition-opacity group-hover/field:opacity-100">?</span>
          )}
          {showTip && description && (
            <div className="absolute left-0 bottom-full z-50 mb-1 w-52 rounded-radius-sm border border-border-subtle bg-surface-overlay px-2.5 py-1.5 text-[10px] leading-relaxed text-text-secondary shadow-md">
              {description}
            </div>
          )}
        </div>
        <input
          type="text"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="h-7 flex-1 rounded-radius-sm border border-border-subtle bg-surface-base px-2 text-[11px] text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent/20"
        />
      </div>
    </div>
  );
}
